var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFollow = function SvgIconFollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M12 3c2.32 0 4.2 1.87 4.2 4.18 0 2.304-1.88 4.18-4.2 4.18-2.322 0-4.2-1.876-4.2-4.18C7.8 4.87 9.677 3 12 3M12 12.555c4.307 0 7.8 2.673 7.8 5.971s-15.6 3.299-15.6 0 3.491-5.971 7.8-5.971"
  })));
};
export default SvgIconFollow;